import React from 'react'
import Container from '@material-ui/core/Container'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import { composeSteps } from './utils'
import { SignupStyledStepper } from 'components/signup-util'
import StepIcon from '../pga-hope-group-event/stepIcon'
import StepContent from './step-content'

const Layout = props => {
  const { shouldShowWaiver, activeStep, paymentRequired } = props
  const steps = composeSteps({ shouldShowWaiver, paymentRequired })

  return (
    <>
      {steps.length > 1 && (
        <SignupStyledStepper activeStep={activeStep} alternativeLabel>
          {steps.map(step => (
            <Step key={step.name}>
              <StepLabel StepIconComponent={StepIcon}>{step.name}</StepLabel>
            </Step>
          ))}
        </SignupStyledStepper>
      )}
      <Container>
        <StepContent {...props} steps={steps} />
      </Container>
    </>
  )
}

export default Layout
